import {assert} from 'assert-ts';
import {useAppSelector} from 'store/hooks';
import type {Metadata} from '../types';
import {selectMetadataEdit} from '../metadataEditSlice';

export const useAssertMetadataEdit = (): Metadata => {
  const metadata = useAppSelector(selectMetadataEdit);
  return assert(metadata.metadata, 'useAssertMetadataEdit: no metadata');
};
